"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkOfTheKunirAbilityHandler = exports.MarkOfTheKunirActorAbilityFactory = exports.MarkOfTheKunirAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
class MarkOfTheKunirAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MarkOfTheKunir;
        this.__typeName = "MarkOfTheKunir";
    }
}
exports.MarkOfTheKunirAbilityArgs = MarkOfTheKunirAbilityArgs;
let MarkOfTheKunirActorAbilityFactory = class MarkOfTheKunirActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MarkOfTheKunir", "Self", 4);
    }
};
MarkOfTheKunirActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MarkOfTheKunir")
], MarkOfTheKunirActorAbilityFactory);
exports.MarkOfTheKunirActorAbilityFactory = MarkOfTheKunirActorAbilityFactory;
let MarkOfTheKunirAbilityHandler = class MarkOfTheKunirAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const amount = container.getLevel(ability.invokerId);
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated: sequence => {
                container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ability.invokerId, 10, "Power")),
                        new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.PoisonDamageIncrease, 50),
                    ], false)
                });
            }
        });
    }
};
MarkOfTheKunirAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MarkOfTheKunir)
], MarkOfTheKunirAbilityHandler);
exports.MarkOfTheKunirAbilityHandler = MarkOfTheKunirAbilityHandler;
